import angular from 'angular';
import { isEmpty, isUndefined, reject } from 'lodash';

function stringifyState(filters) {
  if ((filters.active && filters.upcoming && filters.pending && filters.sold) ||
      (filters.active && filters.upcoming && !filters.pending && !filters.sold)) {
    return '';
  }
  var stateStrings = [
    filters.active ? 'For sale' : undefined,
    filters.pending ? 'Pending' : undefined,
    filters.sold ? 'Sold' : undefined
  ];

  return reject(stateStrings, isUndefined).join(' and ');
}

// Price is stored in cents - we want to convert to thousands of dollars
function stringifyPrice(filters) {
  var minThousands = Math.round(filters.min_price / 100000) || undefined;
  var maxThousands = Math.round(filters.max_price / 100000) || undefined;
  if (minThousands && maxThousands) {
    return `$${minThousands}K–$${maxThousands}K`;
  } else if (minThousands) {
    return `$${minThousands}K+`;
  } else if (maxThousands) {
    return `<$${maxThousands}K`;
  }
  return '';
}

function stringifyBedrooms(filters) {
  if (filters.min_bedrooms) {
    return `${filters.min_bedrooms}+ beds`;
  }
  return '';
}

function stringifyBathrooms(filters) {
  if (filters.min_bathrooms) {
    return `${filters.min_bathrooms}+ baths`;
  }
  return '';
}

function stringifySquareFeet(filters) {
  if (filters.min_sq_ft) {
    return `${filters.min_sq_ft}ft²+`;
  }
  return '';
}

function stringifyPool(filters) {
  if (filters.pool && filters.pool !== "Any") {
    return `${filters.pool.toLowerCase()} pool`;
  }
}

function stringifyParking(filters) {
  if (filters.min_parking) {
    return `${filters.min_parking}+ parking spaces`;
  }
  return '';
}

// Turns a filter object into a string
module.exports = angular.module('common.filters.stringify-filters', [
])
.filter('stringifyFilters', function() {
  return function(filters) {
    return reject([
      stringifyState(filters),
      stringifyPrice(filters),
      stringifyBedrooms(filters),
      stringifyBathrooms(filters),
      stringifyPool(filters),
      stringifyParking(filters),
      stringifySquareFeet(filters),
    ], isEmpty).join(', ') || 'All listings';
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/stringify-filters.js
 **/